import { ApmSDK } from './asyncImportJs';
import {
  CATEGORY_ID,
} from './ubt';

class PAGE_UBT {
  protected pageId: string;

  constructor(pageId: string) {
    this.pageId = pageId;
  }

  // 页面进入埋点
  pageView(businessInfo = {}) {
    // ApmSDK().then(() => {
    const { UBT } = (window as any).TianQi;
    UBT.pageView({
      pageId: this.pageId,
      categoryId: CATEGORY_ID,
      // 业务参数
      businessInfo,
    });
    // });
  }

  // 页面退出埋点
  pageViewOut(businessInfo = {}) {
    // ApmSDK().then(() => {
    const { UBT } = (window as any).TianQi;
    UBT.pageViewOut({
      pageId: this.pageId,
      categoryId: CATEGORY_ID,
      // 业务参数
      businessInfo,
    });
    // });
  }

  // 按钮点击埋点
  clickButton({
    businessInfo = {},
    buttonName = '',
  }) {
    // ApmSDK().then(() => {
    const { UBT } = (window as any).TianQi;
    UBT.clickButton({
      pageId: this.pageId,
      buttonName,
      categoryId: CATEGORY_ID,
      // 业务参数
      businessInfo,
    });
    // });
  }

  // 页面曝光埋点
  moduleExpose({
    businessInfo = {},
    moduleId = '',
  }) {
    // ApmSDK().then(() => {
    const { UBT } = (window as any).TianQi;
    UBT.moduleExpose({
      pageId: this.pageId,
      moduleId,
      exposureTimes: '1',
      contentId: moduleId,
      businessInfo,
    });
    // });
  }
}

// 分享跳转app页面
export const indexUBT = new PAGE_UBT('miaowa_h5_index');
export const groupUBT = new PAGE_UBT('miaowa_h5_chatgroup_share');
export const topicUBT = new PAGE_UBT('miaowa_h5_topicpage');
export const liveRoomUBT = new PAGE_UBT('miaowa_mp_liveroom_share_page');
export const activityUBT = new PAGE_UBT('miaowa_h5_activity');
export const shareMonthlyCardUBT = new PAGE_UBT('miaowa_h5_feedcard');
export const shareInfoCatUBT = new PAGE_UBT('miaowa_h5_share_activity_page');
export const shareBrandCooperationUBT = new PAGE_UBT('miaowa_mp_brand_invite');
export const brandDetailUBT = new PAGE_UBT('miaowa_h5_brand_page');
export const catListUBT = new PAGE_UBT('miaowa_app_catlist_show');

export const animalProtectUBT = new PAGE_UBT('miaowa_app_activity_animal_protect_page');

export const postUBT = new PAGE_UBT('miaowa_app_post_h5_show');
export const shareVipMgmUBT = new PAGE_UBT('miaowa_h5_giftcard_invite_page');
export const springShareUBT = new PAGE_UBT('miaowa_h5_2026rec_invite_page');
export const springActivityUBT = new PAGE_UBT('miaowa_h5_26rec_show');
